import { BiPhone, BiMap } from "react-icons/bi";
import { MdMailOutline } from "react-icons/md";

export const recommendations = [
  {
    name: "Bishnu Tiwari",
    post: "Client",
    message:
      "Darpan handles us, the clients, perfectly, and also the result was as we expected from him.",
    image: "/images/bishnu-tiwari.jpg",
  },
  {
    name: "Aakash B. Aryal",
    post: "Co-Worker",
    message:
      "Darpan is a good companion, helps me anytime, and has a great knowledge of his work. I love his projects.",
    image: "/images/aakash-bandhu-aryal.jpg",
  },
  {
    name: "Dipen Pandit",
    post: "Friend",
    message:
      "Well, it's difficult to term Darpan just as a friend after all, he gets to do his work so perfectly. We had participated on a Hackathon together, where we were the Winner.",
    image: "/images/dipen-pandit.jpg",
  },
  {
    name: "Simran Dhakal",
    post: "Co-Worker",
    message:
      "Darpan not just has great projects, but he manages to finish his projects within the guideline, he marks his words. Well, I love such dedication.",
    image: "/images/simran-dhakal.jpg",
  },
  {
    name: "Mandeep Thapa",
    post: "Developer",
    message:
      "I had just met him, we had a small project done, the time spent was great. Not only he is a team man, but he also has a good sense of humor.",
  },
  {
    name: "Albert R. Timsina",
    post: "Friend",
    message: "Modest, Good Companion, Confident, Matured and well concerned about the works done.",
  }
];

export const projectHeroWidgetData = {
  title: "Ready to order your project?",
  subTitle: "Let me know if you're just interested!",
  mainButton: {
    title: "Contact Me",
    href: "/contact",
  },
  buttons: [
    {
      title: "All Projects",
      href: "/projects",
    },
  ],
};

export const specializations = [
  {
    title: "Backend Development",
    subTitle: "Django | Python",
    desc: "I am a backend developer. I develop websites, APIs, and web services. I use Django as a backend tool, and I also have experience with other technologies like Flask and FastAPI.",
    orderHref: "/order?order_type=backend",
  },
  {
    title: "Cloud Solutions",
    subTitle: "AWS",
    desc: "I can develop cloud solutions using AWS services like EC2, S3, Lambda, Frage, ECS, EKS, etc.. I have experience in deploying applications on the cloud and managing cloud resources.",
    orderHref: "/order?order_type=cloud",
  },
  // frontend
  {
    title: "Frontend Development",
    subTitle: "React | Next.js | JavaScript",
    desc: "I am a frontend developer. I develop user interfaces, applications using React.js and other frontend technologies.",
    orderHref: "/order?order_type=frontend",
  }
];

export const blogHeroWidgetData = {
  title: "Learn what I know!",
  subTitle: "Read my blogs and articles, on Tech and more.",
  mainButton: {
    title: "Blog",
    href: "/blog",
  },
  buttons: [],
};

export const contactDetails = [
  {
    title: "Phone",
    icon: <BiPhone className="icon" />,
    data: "98********",
    href: "tel:9800000000",
  },
  {
    title: "Email",
    icon: <MdMailOutline className="icon" />,
    data: ["darpankattel1@gmail.com", "me@darpankattel.com.np"],
    href: "mailto:darpankattel1@gmail.com",
  },
  {
    title: "Address",
    icon: <BiMap className="icon" />,
    data: "Kathmandu, Nepal",
    href: "https://maps.google.com/?q=kathmandu",
  },
];
